import { useEffect, useState } from 'react';
import { Button, Card, Col, Form, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { updateCustomerByInspectionId } from '../../api/customer';
import { fetchInspectionById, inspectionStatusUpdate } from '../../api/inspection';

const InspectionForm = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [customer, setCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState(null);
    const [files, setFiles] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm(prevForm => ({
            ...prevForm,
            customer: {
                ...prevForm.customer,
                [name]: value
            }
        }));
    };


    const handleFileChange = (e) => {
        setFiles([...e.target.files]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            form.customer.verificationStatus = 'Pending';
            await updateCustomerByInspectionId(form.customer.id, form.customer);
            await inspectionStatusUpdate(id, 'Done');
            Swal.fire({
                icon: 'success',
                title: 'Application Submitted!',
                text: 'Customer profile has been verified successfully.',
                confirmButtonText: 'OK'
            }).then(() => {
                navigate('/field/inspection/scheduled');
            });
        } catch (err) {
            console.error('Error submitting application:', err);
            alert('There was an error. Please try again.');
        }
    };

    useEffect(() => {
        const loadInspection = async () => {
            try {
                const res = await fetchInspectionById(id);
                const inspection = res.data.data;
                setCustomer(inspection);
                setForm(inspection);
            } catch (err) {
                console.error('Error fetching inspection:', err);
            } finally {
                setLoading(false);
            }
        };
        loadInspection();
    }, [id]);

    if (loading || !form) return <p>Loading...</p>;
    if (!customer) return <p>Inspection or customer not found.</p>;

    return (
        <div className="container">
            <h3 className="mb-4">Edit Inspection Schedule</h3>

            <Card className="mb-4">
                <Card.Header className="bg-primary text-white">Customer Info</Card.Header>
                <Card.Body>
                    <p><strong>Account Number:</strong> {customer.customer.accountNumber}</p>
                    <p><strong>Name:</strong> {customer.customer.firstName} {customer.customer.lastName}</p>
                    <p><strong>Address:</strong> {customer.customer.address}</p>
                    <p><strong>Contact:</strong> {customer.customer.mobile1 || customer.customer.mobile2}</p>
                </Card.Body>
            </Card>

            <Tabs defaultActiveKey="meterAddress" className="mb-4">
                <Tab eventKey="meterAddress" title="Meter Address">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}><Form.Group><Form.Label>Latitude</Form.Label><Form.Control type="text" name="latitude" value={form.customer.latitude || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Longitude</Form.Label><Form.Control type="text" name="longitude" value={form.customer.longitude || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Near Meter Number</Form.Label><Form.Control type="text" name="nearMeterNumber" value={form.customer.nearMeterNumber || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Pole No.</Form.Label><Form.Control type="text" name="poleNo" value={form.customer.poleNo || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Route Code</Form.Label><Form.Control type="text" name="routeCode" value={form.customer.routeCode || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Sequence</Form.Label><Form.Control type="text" name="sequence" value={form.customer.sequence || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="serviceDetails" title="Meter Service Details">
                    <Card className="p-3">
                        <Row>
                            <Col md={4}><Form.Group><Form.Label>Bill Deposit</Form.Label><Form.Control type="text" name="billDeposit" value={form.customer.billDeposit || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Feeder Number</Form.Label><Form.Control type="text" name="feederNumber" value={form.customer.feederNumber || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Meter Class</Form.Label><Form.Control type="text" name="meterClass" value={form.customer.meterClass || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Total Cost of Materials</Form.Label><Form.Control type="text" name="totalCostMaterials" value={form.customer.totalCostMaterials || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Type of Meter</Form.Label><Form.Control type="text" name="typeOfMeter" value={form.customer.typeOfMeter || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Connected Load</Form.Label><Form.Control type="text" name="connectedLoad" value={form.customer.connectedLoad || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Total Cost of Labor and Equipment</Form.Label><Form.Control type="text" name="totalCostLaborEquip" value={form.customer.totalCostLaborEquip || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Size of Conductor</Form.Label><Form.Control type="text" name="conductorSize" value={form.customer.conductorSize || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Size of Transformer</Form.Label><Form.Control type="text" name="transformerSize" value={form.customer.transformerSize || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col md={4}><Form.Group><Form.Label>Others</Form.Label><Form.Control type="text" name="others" value={form.customer.others || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Protection</Form.Label><Form.Control type="text" name="protection" value={form.customer.protection || ''} onChange={handleChange} /></Form.Group></Col>
                            <Col md={4}><Form.Group><Form.Label>Transformer Number</Form.Label><Form.Control type="text" name="transformerNumber" value={form.customer.transformerNumber || ''} onChange={handleChange} /></Form.Group></Col>
                        </Row>
                    </Card>
                </Tab>

                <Tab eventKey="attachments" title="Attachments">
                    <Card className="p-3 mb-4">
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label>Upload Files</Form.Label>
                                <Form.Control type="file" multiple onChange={handleFileChange} />
                            </Form.Group>
                            <Button variant="primary" type="submit">
                                Save for verification
                            </Button>
                        </Form>
                    </Card>
                </Tab>
            </Tabs>
        </div>
    );
};

export default InspectionForm;
